import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/manga';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Ethereal%20romantic%20manga%20illustration%20with%20two%20beautiful%20male%20figures%20in%20flowing%20traditional%20clothing%2C%20cherry%20blossom%20petals%20floating%20in%20the%20air%2C%20soft%20dreamy%20atmosphere%2C%20starry%20night%20sky%20with%20galaxy%20and%20nebula%2C%20golden%20light%20particles%2C%20fantasy%20landscape%20with%20ancient%20architecture%20silhouettes%2C%20warm%20amber%20and%20pink%20tones%2C%20ethereal%20and%20poetic%20mood&width=1600&height=900&seq=hero-bg-fumanhua&orientation=landscape"
        alt="腐漫画网 - 精选腐漫推荐"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <p className="text-accent-300 text-sm md:text-base tracking-widest mb-3 animate-fadeIn">
          —— 精选腐漫 · 每日更新 ——
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight animate-fadeInUp">
          {siteInfo.name}
        </h1>
        <p className="text-background-200 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed animate-fadeInUp">
          {siteInfo.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 animate-fadeInUp">
          <Link
            to="/category/hanman-danmei"
            className="px-8 py-3 bg-accent-500 text-background-50 font-medium rounded-full hover:bg-accent-600 transition-all duration-300 whitespace-nowrap text-sm"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-background-300/50 text-background-100 font-medium rounded-full hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap text-sm"
          >
            了解更多
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-300 text-2xl"></i>
      </div>
    </section>
  );
}